import { useState } from "react";
import { Button, Input, Table, Flex, Select } from "antd";
import MenuActions from "../../../../../../../../../../atom/MenuActions";

import { getCurrencyValue } from "../../../../../../../../../../utils/helper/general";
import { getProposalAum } from "../../../../../../../proposal/helper";

const TabClientsLeads = ({
  disableEdit,
  handleActionClientArchive,
  handleActionClientTransfer,
  handleProposalView,
  handleUserNameClick,
  listUsers,
  loading,
}) => {
  const [searchedText, setSearchedText] = useState("");
  const [typeFilter, setTypeFilter] = useState("all");

  console.log({
    listUsers,
  });

  const getFilteredUsers = list => {
    if (typeFilter === "clients") {
      return list?.filter(it => it.userType === "Registered");
    }

    if (typeFilter === "leads") {
      return list?.filter(it => it.userType !== "Registered");
    }

    return list;
  };

  const columns = [
    {
      filteredValue: [searchedText],
      onFilter: (value, record) =>
        String(`${record.firstName} ${record.lastName}`)
          .toLowerCase()
          .includes(value.toLowerCase()),
      render: allValues => (
        <a
          onClick={() =>
            handleUserNameClick({
              activeEmail: allValues.email,
              activeSection: "client",
            })
          }
        >
          {allValues.firstName} {allValues.lastName}
        </a>
      ),
      sorter: (a, b) =>
        `${a.firstName} ${a.lastName}`.localeCompare(
          `${b.firstName} ${b.lastName}`
        ),
      title: "Name",
    },
    {
      render: allValues => (
        <a
          onClick={() =>
            handleUserNameClick({
              activeEmail: allValues.advisorEmail,
              activeSection: "advisor",
            })
          }
        >
          {allValues.advisorName}
        </a>
      ),
      title: "Advisor",
    },
    {
      render: allValues =>
        allValues.userType === "Registered" ? "Client" : "Lead",
      title: "Type",
    },
    {
      align: "right",
      className: "cell-accent",
      render: allValues =>
        getCurrencyValue(
          allValues.valueMap?.leadInitial?.assets ??
            allValues.valueMap?.guideInitialData?.assets
        ),
      sorter: (a, b) =>
        (a.valueMap?.leadInitial?.assets ??
          a.valueMap?.guideInitialData?.assets) -
        (b.valueMap?.leadInitial?.assets ??
          b.valueMap?.guideInitialData?.assets),
      title: "Initial Investable Assets",
    },
    {
      align: "right",
      render: allValues =>
        getCurrencyValue(getProposalAum(allValues.valueMap.productMap)),
      title: "Proposal AUM",
    },
    {
      align: "center",
      render: allValues => (
        <Flex justify="center">
          <Button
            disabled={!allValues.valueMap.productMap}
            onClick={() =>
              handleProposalView(allValues.email, allValues.advisorEmail)
            }
            shape="round"
            size="small"
          >
            View Proposal
          </Button>
        </Flex>
      ),
      title: "Proposal Action",
    },
    {
      className: "actions-menu-table-cell",
      render: allValues => (
        <MenuActions
          items={[
            {
              disabled: true,
              // disabled: disableEdit,
              key: "transfer",
              label: "Transfer Client/Leads",
              onClick: () => handleActionClientTransfer(allValues.email),
            },
            {
              disabled: disableEdit,
              key: "archive",
              label: "Archive Client/Lead",
              onClick: () => handleActionClientArchive(allValues.email),
            },
          ]}
        />
      ),
      width: 40,
    },
  ];

  const options = [
    {
      label: "Client/Leads",
      value: "all",
    },
    {
      label: "Clients",
      value: "clients",
    },
    {
      label: "Leads",
      value: "leads",
    },
  ];

  return (
    <Flex gap={24} vertical>
      <Flex gap={32}>
        <Input
          style={{
            maxWidth: 200,
            height: 37,
            borderRadius: 25,
          }}
          placeholder="Search..."
          onChange={event => setSearchedText(event.target.value)}
        />

        <Flex align="center" gap={8}>
          Show
          <Select
            onChange={setTypeFilter}
            options={options}
            style={{ width: 193 }}
            value={typeFilter}
          />
        </Flex>
      </Flex>

      <Table
        columns={columns}
        dataSource={getFilteredUsers(
          listUsers?.map(it => ({
            ...it,
            key: it.email,
          }))
        )}
        loading={loading}
        pagination={false}
        rowHoverable={false}
        size="small"
      />
    </Flex>
  );
};

export default TabClientsLeads;
